/** Shared kernel — ADR-005 / DP-02 / DP-04 */
export const DEFAULT_CURRENCY = 'GBP' as const;
export const LONDON_TIMEZONE = 'Europe/London' as const;
